import React from 'react'
import PropTypes from 'prop-types'

const EmptyList = ({ title, text, children }) => (
  <div className="empty-list">
    <h3>{title}</h3>
    {text && <p>{text}</p>}
    {children}
  </div>
)

EmptyList.defaultProps = {
  children: null,
  text: '',
}

EmptyList.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.element,
}

export default EmptyList



// WEBPACK FOOTER //
// ./src/browser/components/EmptyList.js